export default "__VITE_ASSET__N$174OVY__"